import React, { useState } from "react";
import axios from "axios";
import swal from "sweetalert";
import SweetAlert from "react-bootstrap-sweetalert";
import { Sidebar } from "primereact/sidebar";
import arrow from "../../../../assets/profile/navigatenext.svg";
import * as appConstants from "../../../../constants/index";
import { postDataService } from "src/services/postApiService";
import { ProceedButton } from "../../../gift-cards/giftCardTags";
import angle_left from "../../../../assets/mobilemoviedetail/arrow-b.svg";
import savedCardIcon from "../../../../assets/payment/savecard.svg";
import Upimandate from "../../../../assets/nav-icon/UPIMandate.svg";

import "./mandate.css";

const UpimandateMobile = ({ type }) => {
    const theme = localStorage.getItem("theme");
    const [loading, setLoading] = useState(false);
    const [savedCardList, setSavedCardList] = useState([]);
    const [showConfirm, setShowConfirm] = useState(false);
    const [selectedCard, setSelectedCard] = useState(null);
    const [sidebarVisible, setSidebarVisible] = useState(false);

    // MASK VPA
    const maskVPA = (vpa) => {
        if (!vpa) return "";
        const [name, domain] = vpa.split("@");
        if (!name || !domain) return vpa;
        const first = name.slice(0, 2);
        const last = name.slice(-2);
        return `${first}****${last}@${domain}`;
    };

    // GA event
    const hitGa = (event) => {
        let dataLayer = window["dataLayer"] || [];
        dataLayer.push({ event });
    };

    // FETCH MANDATES
    const getSavedCardList = async () => {
        setLoading(true);

        const postData = {
            transId: 0,
            bookingId: "",
            bookType: "BOOKING",
            paytype: "UPI",
            pgtype: "RAZORPAY",
            mandate: true,
            dtmSource: "dd",
            tokenId: "",
        };

        try {
            const res = await axios.post(
                `${appConstants.base_url}v1/payment/optimizer/init`,
                postData,
                {
                    headers: {
                        Authorization: `Bearer ${sessionStorage.getItem("token") || ""}`,
                        chain: theme === "inoxTheme" ? "INOX" : "PVR",
                        city: localStorage.getItem("city"),
                        appVersion: appConstants.av,
                        platform: appConstants.pt,
                        country: appConstants.cname,
                        dtoken: "abc1234",
                        did: "data1234",
                    },
                }
            );

            if (res.data.result === "success") {
                setSavedCardList(res?.data?.output?.list_cards || []);
            } else {
                swal({
                    title: "Error",
                    text: res.data.msg || "Failed to fetch mandates",
                    icon: "error",
                });
            }
        } catch (error) {
            console.error("Error fetching mandates:", error);
            swal({
                title: "Error",
                text: "Something went wrong! Please try again.",
                icon: "error",
            });
        }

        setLoading(false);
    };

    // CANCEL MANDATE
    const cancelMandate = async () => {
        if (!selectedCard) return;

        setLoading(true);
        setShowConfirm(false); // close confirm dialog

        const postData = { token: selectedCard?.card_token };

        try {
            const response = await axios.post(
                `${appConstants.base_url}v1/payment/optimizer/mandate/cancel`,
                postData,
                {
                    headers: {
                        Authorization: `Bearer ${sessionStorage.getItem("token") || ""}`,
                        chain: theme === "inoxTheme" ? "INOX" : "PVR",
                        city: localStorage.getItem("city"),
                        appVersion: appConstants.av,
                        platform: appConstants.pt,
                        country: appConstants.cname,
                        dtoken: "abc1234",
                        did: "data1234",
                    },
                }
            );

            const data = response?.data;

            if (data?.result === "success") {
                swal({
                    title: "Success",
                    text: data?.msg || "Mandate successfully cancelled",
                    icon: "success",
                    buttons: false,
                    timer: 2000,
                });

                // Refresh mandate list
                getSavedCardList();
            } else if (data?.result === "error" || data?.result === "dialog") {
                swal({
                    text: data?.msg || "Something went wrong",
                    timer: 2000,
                    className: "swal-top-alert",
                    icon: "error",
                    buttons: false,
                });
            }
        } catch (error) {
            console.error("Error cancelling mandate:", error);

            swal({
                text: "Unable to cancel mandate. Please try again.",
                icon: "error",
                buttons: false,
                timer: 2000,
            });
        } finally {
            setLoading(false);
        }
    };

    // MANDATE DISPLAY
    const MandateContent = () => (
        <div className="upi-mandate-container" style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
            {loading ? (
                <p className="text-center">Loading...</p>
            ) : savedCardList?.filter((c) => c?.mandate)?.length === 0 ? (
                <p className="text-center">No UPI mandates found</p>
            ) : (
                savedCardList
                    .filter((item) => item?.mandate)
                    .map((card) => (
                        <div
                            key={card.card_token}
                            className="upi-box"
                            style={{ border: "1px solid #ccc", padding: "10px", borderRadius: "5px" }}
                        >
                            {card.vpa && (
                                <p><strong>VPA:</strong> {card.vpa}</p>
                            )}
                            <p><strong>Total Amount:</strong> ₹{card.mandateTotalAmount}</p>
                            <p><strong>Remaining Amount:</strong> ₹{card.mandateRemainingAmount}</p>
                            <ProceedButton
                                className="cancel-btn"
                                onClick={() => {
                                    setSelectedCard(card);
                                    setShowConfirm(true);
                                }}
                            >
                                Cancel
                            </ProceedButton>
                        </div>
                    ))
            )}
        </div>
    );

    return (
        <>
            {/* UPI Reserve Button */}
            <div
                className="profile-img border-line-profile"
                onClick={() => {
                    hitGa("upi_reserve");
                    setSidebarVisible(true);
                    getSavedCardList(); // fetch only on click
                }}
            >
                <div className="profile-text profile-account">
                    <h4>
                        <span className="avtar">
                            <img src={Upimandate} alt="" className="Upimandate" />
                        </span>
                    </h4>
                    <div className="profile-text-info"><h2>UPI Reserve Pay </h2></div>
                </div>
                <div className="img-arrow"><img src={arrow} alt="arrow" /></div>
            </div>

            {/* MOBILE SIDEBAR */}
            <Sidebar
                visible={sidebarVisible}
                showCloseIcon={false}
                position="right"
                className="Mybookinghistory-mobile"
                style={{ width: "100vw" }}
                onHide={() => setSidebarVisible(false)}
                fullScreen
            >
                <div className="Account-view-show-mobile">
                    <div
                        className="account-angle-btn"
                        onClick={() => setSidebarVisible(false)}
                    >
                        <h4>
                            <img src={angle_left} alt="" className="" /> &nbsp; UPI Reserve Pay
                        </h4>
                    </div>
                </div>
                <div className="luxe-divider" style={{ margin: "3px 0" }}></div>
                <MandateContent />
            </Sidebar>

            {/* CONFIRM CANCEL DIALOG */}
            <SweetAlert
                warning
                show={showConfirm}
                title="Are you sure?"
                onConfirm={cancelMandate}
                onCancel={() => setShowConfirm(false)}
                confirmBtnText="Yes"

                confirmBtnCssClass={
                    theme === "inoxTheme"
                        ? "confirm-btn-inox border-0"
                        : "confirm-btn-pvr border-0"
                }
                showCancel
            >
                You want to cancel this UPI mandate!
            </SweetAlert>
        </>
    );
};

export default UpimandateMobile;